import React, { Component } from "react"
import { Card, CardBody} from 'mdbreact';

const VendorCard = props => {      
    // const classes = props.checked ? "inverse-card" : ""    
    return (
      <div className={"col-md-4 col-xs-12 col-sm-6 col-lg-3 col-center-block inverse-card"} onClick={props.onClick}>      
        <Card>
          <CardBody>
              {/* <h5 className="pink-text"><i className="fa fa-trophy"> </i> {props.title}</h5>                 */}
              <div className="card-body">
                <h4 className="card-title text-center vendorName">
                  <strong>
                    {props.text}
                  </strong>
                </h4>                
              </div>              
          </CardBody>
        </Card>
        <hr></hr>
      </div>
      )
}

export default VendorCard


// WEBPACK FOOTER //
// ./src/Components/Card.js